/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Draft_Count_AddedInputs */

const en_us2_draft_count_added = /** @type {(inputs: Draft_Count_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 in`);
	return /** @type {LocalizedString} */ (`${i?.count} in`)
	
};

const pt_br2_draft_count_added = /** @type {(inputs: Draft_Count_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 entra`);
	return /** @type {LocalizedString} */ (`${i?.count} entram`)
	
};

const es_419_draft_count_added = /** @type {(inputs: Draft_Count_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 entra`);
	return /** @type {LocalizedString} */ (`${i?.count} entran`)
	
};

const pt_pt2_draft_count_added = /** @type {(inputs: Draft_Count_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 entra`);
	return /** @type {LocalizedString} */ (`${i?.count} entram`)
	
};

const fr_fr2_draft_count_added = /** @type {(inputs: Draft_Count_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ajout`);
	return /** @type {LocalizedString} */ (`${i?.count} ajouts`)
	
};

const de_de2_draft_count_added = /** @type {(inputs: Draft_Count_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 neu`);
	return /** @type {LocalizedString} */ (`${i?.count} neu`)
	
};

const it_it2_draft_count_added = /** @type {(inputs: Draft_Count_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 entra`);
	return /** @type {LocalizedString} */ (`${i?.count} entrano`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 in" |
* | * | "{count} in" |
*
* @param {Draft_Count_AddedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_count_added = /** @type {((inputs: Draft_Count_AddedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Count_AddedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_count_added(inputs)
	if (locale === "es-419") return es_419_draft_count_added(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_count_added(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_count_added(inputs)
	if (locale === "de-DE") return de_de2_draft_count_added(inputs)
	if (locale === "it-IT") return it_it2_draft_count_added(inputs)
	return en_us2_draft_count_added(inputs)
});
export { draft_count_added as "draft.count_added" }